<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <h4>{{ $t('modals.deleteGroup.title') }}</h4>
      <p v-html="$t('modals.deleteGroup.confirmQuestion', { name: groupName })"></p>

      <div v-if="itemCount > 0" class="form-check my-3">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="deleteContent"
          id="deleteContentCheck"
        />
        <label class="form-check-label" for="deleteContentCheck">
          {{ $t('modals.deleteGroup.alsoDeleteContent', { count: itemCount }) }}
        </label>
      </div>
      <p v-if="deleteContent" class="text-danger small">
        {{ $t('modals.deleteGroup.warningIrreversible') }}
      </p>
      <p v-else class="text-muted small">
        {{ $t('modals.deleteGroup.warningUngrouped') }}
      </p>

      <div class="modal-actions">
        <button class="btn btn-outline-secondary" @click="$emit('cancel')">
          {{ $t('common.cancel') }}
        </button>
        <button class="btn btn-danger" @click="confirm">{{ $t('common.confirm') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteGroupModal",
  props: {
    groupName: String,
    itemCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      deleteContent: false,
    };
  },
  methods: {
    confirm() {
      this.$emit("confirm", { deleteContent: this.deleteContent });
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}
.form-check-label {
  user-select: none;
}
</style>
